import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d3e36fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 bg-white rounded-4 shadow p-0 m-0 mt-5" }
const _hoisted_2 = { class: "m-4" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = {
  key: 0,
  class: "reload-error"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo cursor-pointer fs-3 color-icon" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-error" }, "Error Api", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "m-4" }
const _hoisted_13 = {
  key: 0,
  class: "text-center"
}
const _hoisted_14 = {
  key: 1,
  class: "text-center"
}
const _hoisted_15 = {
  key: 2,
  class: "text-center"
}
const _hoisted_16 = { class: "data-number" }
const _hoisted_17 = { class: "data-number" }
const _hoisted_18 = { class: "data-number" }
const _hoisted_19 = { class: "data-number" }
const _hoisted_20 = { class: "data-number" }
const _hoisted_21 = { class: "fs-75 mt-3" }
const _hoisted_22 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_23 = { class: "mt-3 d-flex" }
const _hoisted_24 = { class: "d-flex align-items-center ms-3 total-number" }

import { translate } from '@/languages/i18n'
import PaginationModal from '@/components/pagination/paginationContractHistory.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Table from '@/components/table/DashBoardTable.vue'
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import communityDashboardService from '@/services/community-dashboard.services'
import { numberWithCommas } from '@/constants/common.ts'
import _ from 'lodash'


export default /*#__PURE__*/_defineComponent({
  props: {
  date: {
    type: Object,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()
const pageOfNumber = ref(30)
const curPage = ref(1)
const action_type = ref('posts_1')
const sort = ref('desc')
const total_pages = ref(1)
const dataListUser = ref([])
const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])
const loading = ref(false)
const errorCallApi = ref(false)

onMounted(() => {
  getDataListUser()
})
watch(
  () => props.date?.from,
  () => {
    curPage.value = 1
    getDataListUser()
  }
)
watch(
  () => props.date?.to,
  () => {
    curPage.value = 1
    getDataListUser()
  }
)

const changeQuery = (query: any): void => {
  pageOfNumber.value = query?.page_of_number
  curPage.value = query?.page
  getDataListUser()
}

const changeSort = (query: any): void => {
  curPage.value = 1
  //2022/11/12 TienNV Fix for UAT Phase2#5120: CB10 (Ph2-R20221116)
  action_type.value = Object.keys(query)[0]
  sort.value = Object.values(query)[0]
  getDataListUser()
}

const getDataListUser = async () => {
  loading.value = true
  try {
    const res = await communityDashboardService.getActions(route.params.id, {
      from: props.date?.from ?? '',
      to: props.date?.to ?? '',
      //2022/11/12 TienNV Fix for UAT Phase2#5120: CB10 (Ph2-R20221116)
      page: curPage.value,
      page_of_number: pageOfNumber.value,
      action_type: action_type.value,
      sort: sort.value,
    })
    if (res.data?.success) {
      errorCallApi.value = false
      total_pages.value = res?.data.total_pages
      dataListUser.value = res?.data.data
    } else {
      errorCallApi.value = true
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_unref(translate)('CB10titleListUser')), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      (!loading.value && errorCallApi.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: getDataListUser,
            class: "reload-error"
          }, _hoisted_11))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _withDirectives(_createVNode(Table, {
        columns: [
          { field: 'user_name', name: _unref(translate)('CB10userName') },
          { field: 'user_type', name: _unref(translate)('CB10attribute') },
          { field: 'posts_1', name: _unref(translate)('CB10numberArticlesPosted'), sort: _ctx.sortField === 'posts_1', classTh: 'class-text-right', activeSort: true },
          { field: 'posts_2', name: _unref(translate)('CB10NumberRecruitmentPosts'), sort: _ctx.sortField === 'posts_2', classTh: 'class-text-right' },
          { field: 'interests', name: _unref(translate)('CB10NumberInterests'), sort: _ctx.sortField === 'interests', classTh: 'class-text-right' },
          { field: 'likes', name: _unref(translate)('CB10NumberLikesUser'), sort: _ctx.sortField === 'likes', classTh: 'class-text-right' },
          { field: 'invited_count', name: _unref(translate)('CB10NumberInvitations'), sort: _ctx.sortField === 'invited_count', classTh: 'class-text-right' },
        ],
        sortCells: ['posts_1', 'posts_2', 'interests', 'likes', 'invited_count'],
        onChangeSort: changeSort,
        pageOfNumber: pageOfNumber.value,
        curPage: curPage.value,
        idTable: 'actionTable'
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataListUser.value, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: _normalizeClass({ rowEven: index % 2 === 0 })
            }, [
              _createElementVNode("td", null, _toDisplayString(item?.user_name), 1),
              (item?.user_type === 'alumni')
                ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString('アルムナイ')))
                : (item?.user_type === 'employee')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString('在籍')))
                  : (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString('管理'))),
              _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(numberWithCommas)(item?.posts_1)), 1),
              _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(numberWithCommas)(item?.posts_2)), 1),
              _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(numberWithCommas)(item?.interests)), 1),
              _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(numberWithCommas)(item?.likes)), 1),
              _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(numberWithCommas)(item?.invited_count)), 1)
            ], 2))
          }), 128))
        ]),
        _: 1
      }, 8, ["columns", "pageOfNumber", "curPage"]), [
        [_vShow, !loading.value]
      ]),
      _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(translate)('CB10likeUser')), 1),
      (dataListUser.value?.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(translate)('CB10NoData')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(PaginationModal, {
          totalPage: total_pages.value || 1,
          onChangeQuery: changeQuery,
          isNotFilterUrl: true,
          pageOfNumber: pageOfNumber.value,
          curPage: curPage.value
        }, null, 8, ["totalPage", "pageOfNumber", "curPage"]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number',
            onChangeQuery: changeQuery,
            isNotFilterUrl: true,
            pageOfNumber: pageOfNumber.value
          }, null, 8, ["options", "pageOfNumber"])
        ])
      ])
    ], 512), [
      [_vShow, !loading.value && !errorCallApi.value]
    ])
  ]))
}
}

})